import { curry, assoc } from 'ramda';

const toggleProp = curry((key, obj) => assoc(key, !obj[key], obj));

export default toggleProp;
